const LOWER = 'abcdefghjkmnpqrstuvwxyz';
const UPPER = 'ABCDEFGHJKMNPQRSTUVWXYZ';
const NUMBERS = '23456789';
const SYMBOLS = '!@#$%&*?';

function randomIndex(length) {
  const values = new Uint32Array(1);
  window.crypto.getRandomValues(values);
  return values[0] % length;
}

function pick(characters) {
  return characters[randomIndex(characters.length)];
}

export function generatePassword(policy) {
  const required = [];
  if (policy?.requireLowercase) required.push(LOWER);
  if (policy?.requireUppercase) required.push(UPPER);
  if (policy?.requireNumber) required.push(NUMBERS);
  if (policy?.requireSymbol) required.push(SYMBOLS);

  const all = LOWER + UPPER + NUMBERS + SYMBOLS;
  const length = Math.max(policy?.minLength || 12, 16, required.length);
  const characters = required.map(pick);
  while (characters.length < length) characters.push(pick(all));

  for (let index = characters.length - 1; index > 0; index -= 1) {
    const swap = randomIndex(index + 1);
    [characters[index], characters[swap]] = [characters[swap], characters[index]];
  }
  return characters.join('');
}

export function passwordPolicySummary(policy) {
  if (!policy) return 'Loading password requirements…';
  const requirements = [`${policy.minLength} or more characters`];
  if (policy.requireUppercase) requirements.push('an uppercase letter');
  if (policy.requireLowercase) requirements.push('a lowercase letter');
  if (policy.requireNumber) requirements.push('a number');
  if (policy.requireSymbol) requirements.push('a symbol');
  return requirements.join(', ');
}
